import { useAutoAnimate } from "@formkit/auto-animate/react";
import { ServicioTransporte } from "../../services/transporteServicios";
import ListaTarifas from "./ListaTarifas";
import Tarifa from "./Tarifa";
import styled from "styled-components";

const SeccionTarifas = ({
  tipoTrayecto,
  tarifas,
  onSeleccionarTarifa,
  isLoading,
  tarifaSeleccionada,
}: {
  tipoTrayecto: "ida" | "vuelta" | "ida_y_vuelta";
  tarifas: ServicioTransporte[];
  onSeleccionarTarifa: (tarifa: ServicioTransporte) => void;
  isLoading: boolean;
  tarifaSeleccionada?: ServicioTransporte;
}) => {
  const [animationParent] = useAutoAnimate<HTMLDivElement>();

  const buildTitulo = () => {
    switch (tipoTrayecto) {
      case "ida":
        return "ida";
      case "vuelta":
        return "vuelta";
      case "ida_y_vuelta":
        return "ida y vuelta";
      default:
        return "";
    }
  };

  return (
    <section className="mb-3" ref={animationParent}>
      <h5 className="mb-3">{`Transporte de ${buildTitulo()}`}</h5>
      {!isLoading && tarifas && tarifas.length > 1 && (
        <div className="mb-3">
          <ListaTarifas
            tarifas={tarifas}
            onSeleccionarTarifa={onSeleccionarTarifa}
            tarifaSeleccionada={tarifaSeleccionada}
          />
        </div>
      )}
      {!isLoading && tarifas.length === 1 && <Tarifa tarifa={tarifas[0]} />}

      {!isLoading && tarifas.length === 0 && (
        <Advertencia>
          {
            "No hay tarifas compatibles con estos parámetros. Por favor configure un plan de servicios en la sección Servicios o no use tarifas para este trayecto."
          }
        </Advertencia>
      )}

      {isLoading && <div className="mb-3">Buscando tarifas...</div>}
      <hr />
    </section>
  );
};

const Advertencia = styled.i`
  color: ${(props) => props.theme.colors.error};
`;

export default SeccionTarifas;
